
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke123aRequest, Sgke123aResponse, Sgke123aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke123aService {

  /**
   * コンストラクタ
   * @param {Sgke123aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke123aService
   */
  constructor(
    public service: Sgke123aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE123A_入金突合承認API呼び出し
   * @param {Sgke123aRequest} request 
   * @returns {Observable<Sgke123aResponse>}
   * @memberof UsedSgke123aService
   */
  public doSgke123a(request: Sgke123aRequest): Observable<Sgke123aResponse> {
    return this.service.sgke123aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE123A');
          return throwError(err.message);
        })
      );
  }

}
